import { Outlet } from "react-router-dom";

/**
 * The route frame of the tools section, and nothing else.
 *
 * It used to print the section's title and a second navigation rail around
 * each page, so a tool's page stacked two `h2 text-2xl` ("Outils et
 * intégrations", then the tool's name) beside a menu repeating the list the
 * page itself shows. Each page now carries its own header: the list is the
 * section, and a tool's page goes back to it (`backTo`).
 */
export function ToolsLayout() {
  return <Outlet />;
}
